<template>
    <popup-modal
        @close="close"
        position="center"
    >

        <div>
            <div class="flex space-x-24 items-start">
                <button
                    v-for="style in styles"
                    :key="'style-' + style.name"
                    class="w-96"
                    :class="[ style.name === activeStyle ? 'cursor-default' : 'cursor-pointer']"
                    :disabled="style.name === activeStyle"
                    @click="switchToStyle(style.name)"
                >
                    <div
                        class="rounded border p-8 flex items-center justify-center h-96 w-full relative mb-16 trans-ease group hover:border-secondary"
                        :class="[ (style.name === activeStyle && !switchingToStyle) || switchingToStyle === style.name ? 'border-secondary' : 'border-primary-40' ]"
                    >
                        <div v-if="switchingToStyle === style.name">
                            <loading size="small" color="green"></loading>
                        </div>
                        <div v-else class="w-full h-full relative">
                            <div class="absolute inset-0 flex items-center justify-center">
                                <svg-icon
                                    class="text-primary-40 trans-ease"
                                    size="48"
                                    :type="style.icon"
                                />
                            </div>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <svg-icon
                                    class="text-secondary trans-ease group-hover:opacity-100"
                                    :class="[ (style.name === activeStyle) && !switchingToStyle ? 'opacity-100' : 'opacity-0' ]"
                                    size="48"
                                    :type="style.icon"
                                />
                            </div>
                        </div>
                        <div
                            class="absolute inset-x-0 bottom-0 flex justify-center -mb-8 trans-ease"
                            :class="[ ((style.name === activeStyle) && !switchingToStyle) || switchingToStyle === style.name ? 'opacity-100' : 'opacity-0' ]"
                        >
                            <svg-icon
                                type="check-circle"
                                size="16"
                                class="text-secondary bg-white trans-ease"
                            ></svg-icon>
                        </div>
                    </div>
                    <div class="leading-snug text-center first-letter:uppercase text-primary-80">{{ style.title }}</div>
                </button>
            </div>
        </div>

    </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue';
import SvgIcon from './SvgIcon.vue';
import Component from '../../models/Component';
import * as components from '../../services/ComponentService';
import Loading from './Loading.vue';
import {useRepo} from "pinia-orm";

export default {
    components: {
        'popup-modal': PopupModal,
        'svg-icon': SvgIcon,
        'loading': Loading,
    },
    props: {
        styles: Array,
        currentStyle: String,
        component: Component,
    },
    data: function () {
        return {
            switchingToStyle: null,
        }
    },
    computed: {
        activeStyle () {
            return this.styles.map(style => style.name).includes(this.currentStyle)
                ? this.currentStyle
                : this.styles[0].name;
        }
    },
    methods: {
        close () {
            this.$emit('close');
        },
        switchToStyle (style) {

            this.switchingToStyle = style;

            components.update(this.component.id, {
                data: {
                    component_type: this.component.type,
                    attributes: {
                        settings: Object.assign(this.component.settings || {}, { style }),
                    }
                }
            }).then(result => {
                return useRepo(Component).where('id', this.component.id).update({
                    settings: result.attributes.settings,
                    style,
                });
            }).then(updates => {
                this.switchingToStyle = null;
                this.$emit('close');
            });
        }
    }
}
</script>
